<div class="user-search" *ngIf="isVisible">
  <input
    *ngIf="searchInputEnabled"
    (input)="onInput($event)"
    (change)="onUserSelected($event)"
    class="users-input kinput kbody-medium"
    type="text"
    placeholder="Search users..."
    aria-label="Search users"
    autocomplete="off"
    list="usersearch"
  >
  <datalist id="usersearch">
    <option class="kbody-medium" *ngFor="let user of users">{{ user.fullName }}</option>
  </datalist>
</div>
